export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_NOTIFICATIONS_BLOCKED = 'SET_NOTIFICATIONS_BLOCKED'
export const SIGNIN = 'SIGNIN'
export const SIGNOUT = 'SIGNOUT'
export const SET_USER_PROFILE = 'SET_USER_PROFILE'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN'
export const SET_IS_REFRESHING = 'SET_IS_REFRESHING'
export const SET_THEME = 'SET_THEME'
export const SET_SIGNIN_FALLBACK = 'SET_SIGNIN_FALLBACK'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const GET_EMPLOYEES = 'GET_EMPLOYEES'
export const UPDATE_BANK_INFO = 'UPDATE_BANK_INFO'
export const UPDATE_BANKS_LIST = 'UPDATE_BANKS_LIST'
export const UPDATE_BRANCH_BANKS_LIST = 'UPDATE_BRANCH_BANKS_LIST'
export const LOADING_USER_CATEGORY = 'LOADING_USER_CATEGORY'
export const LOAD_USER_CATEGORY_SUCCESS = 'LOAD_USER_CATEGORY_SUCCESS'
export const UPDATE_USER_CATEGORIES = 'UPDATE_USER_CATEGORIES'
export const UPDATE_USER_CATEGORY_GROUPS = 'UPDATE_USER_CATEGORY_GROUPS'
export const UPDATE_USER_BUSINESS = 'UPDATE_USER_BUSINESS'
export const ADD_USER_CATEGORY = 'ADD_USER_CATEGORY'
export const LOAD_REMOTE_CONFIGS_SUCCESS = 'LOAD_REMOTE_CONFIGS_SUCCESS'
export const LOADING_SAVED_PLACES = 'LOADING_SAVED_PLACES'
export const LOAD_SAVED_PLACES_SUCCESS = 'LOAD_SAVED_PLACES_SUCCESS'
export const LOADED_SAVED_PLACES = 'LOADED_SAVED_PLACES'
export const ADD_LOCAL_SAVED_PLACE = 'ADD_LOCAL_SAVED_PLACE'
export const REMOVE_LOCAL_SAVED_PLACE = 'REMOVE_LOCAL_SAVED_PLACE'
export const SET_WEB_IN_APP_CONFIG = 'SET_WEB_IN_APP_CONFIG'
export const SET_USER_BALANCE = 'SET_USER_BALANCE'
export const SET_PARTNER_GET_FROM_TOKEN = 'SET_PARTNER_GET_FROM_TOKEN'

export const RESET_ORDER_FORM = 'RESET_ORDER_FORM'
export const RESET_TRUCK_FORM = 'RESET_TRUCK_FORM'
export const RESET_ORDER_PATH = 'RESET_ORDER_PATH'
export const INIT_ORDER_FORM_PATH = 'INIT_ORDER_FORM_PATH'
export const SET_ORDER_FORM_PATH = 'SET_ORDER_FORM_PATH'
export const SET_ORDER_FORM_SERVICE = 'SET_ORDER_FORM_SERVICE'

export const ADD_ORDER_FORM_REQUESTS = 'ADD_ORDER_FORM_REQUESTS'
export const REMOVE_ORDER_FORM_REQUESTS = 'REMOVE_ORDER_FORM_REQUESTS'

export const SET_ORDER_FORM_ESTIMATED_FEE = 'SET_ORDER_FORM_ESTIMATED_FEE'
export const SET_ORDER_FORM_ESTIMATE_FEE_TIMEOUT = 'SET_ORDER_FORM_ESTIMATE_FEE_TIMEOUT'
export const SET_ORDER_FORM_ESTIMATING_FEE = 'SET_ORDER_FORM_ESTIMATING_FEE'
export const SET_ORDER_FORM_ESTIMATE_FEE_ERROR = 'SET_ORDER_FORM_ESTIMATE_FEE_ERROR'
export const SET_ORDER_FORM_CREATING_ORDER = 'SET_ORDER_FORM_CREATING_ORDER'

export const GET_ORDER_FORM_ESTIMATED_FEE = 'GET_ORDER_FORM_ESTIMATED_FEE'
export const SET_ORDER_FORM_ESTIMATED_FEE_ALL_SERVICES = 'SET_ORDER_FORM_ESTIMATED_FEE_ALL_SERVICES'
export const SET_ORDER_FORM_SUGGEST_SERVICE_ALL_SERVICES =
  'SET_ORDER_FORM_SUGGEST_SERVICE_ALL_SERVICES'

export const SET_ORDER_FORM_PROMO_CODE = 'SET_ORDER_FORM_PROMO_CODE'
export const SET_ORDER_FORM_REMARKS = 'SET_ORDER_FORM_REMARKS'
export const SET_ORDER_FORM_ORDER_TIME = 'SET_ORDER_FORM_ORDER_TIME'
export const SET_ORDER_FORM_IMAGES = 'SET_ORDER_FORM_IMAGES'
export const SET_ORDER_FORM_ALL_INFO = 'SET_ORDER_FORM_ALL_INFO'
export const SET_ORDER_FORM_PAYMENT_METHOD = 'SET_ORDER_FORM_PAYMENT_METHOD'
export const RESET_ORDER_FORM_ESTIMATE_FEE = 'RESET_ORDER_FORM_ESTIMATE_FEE'
export const SET_METHOD_PICKED = 'SET_METHOD_PICKED'
export const SET_INSURANCE_SERVICE = 'SET_INSURANCE_SERVICE'

export const RESET_NEARBY_SUPPLIERS = 'RESET_NEARBY_SUPPLIERS'
export const GET_NEARBY_SUPPLIERS = 'GET_NEARBY_SUPPLIERS'
export const INIT_GET_NEARBY_SUPPLIERS_INTERVAL = 'INIT_GET_NEARBY_SUPPLIERS_INTERVAL'
export const CLEAR_GET_NEARBY_SUPPLIERS_INTERVAL = 'CLEAR_GET_NEARBY_SUPPLIERS_INTERVAL'
export const SET_ACTIVATED_POINT_MARKER = 'SET_ACTIVATED_POINT_MARKER'

export const SET_ORDERS = 'SET_ORDERS'
export const SET_ORDERS_UPDATE = 'SET_ORDERS_UPDATE'
export const SET_ORDERS_ADD_NEW = 'SET_ORDERS_ADD_NEW'
export const SET_ORDERS_DEFAULT_FILTER = 'SET_ORDERS_DEFAULT_FILTER'
export const SET_ORDERS_SCROLL_POSITION = 'SET_ORDERS_SCROLL_POSITION'
export const SET_ORDERS_OFFSET = 'SET_ORDERS_OFFSET'
export const SET_ORDERS_TOTAL = 'SET_ORDERS_TOTAL'
export const SET_ACTIVE_ORDER = 'SET_ACTIVE_ORDER'

export const SET_ORDER_STATUS = 'SET_ORDER_STATUS'
export const SET_ORDER_ID = 'SET_ORDER_ID'
export const SET_ORDER_ACTIVE_PATH = 'SET_ORDER_ACTIVE_PATH'

export const SET_NAVIGATION_DRAWER = 'SET_NAVIGATION_DRAWER'
export const SET_NAVIGATION_MINI = 'SET_NAVIGATION_MINI'
export const SET_NAVIGATION_HIDDEN = 'SET_NAVIGATION_HIDDEN'

export const SET_APP_VERSION_1 = 'SET_APP_VERSION_1'
export const SET_ISFOCUS_TAB = 'SET_UNFOCUS_TAB'
export const SET_NETWORK_CONNECTION = 'SET_NETWORK_CONNECTION'

export const SET_SNACKBAR = 'SET_SNACKBAR'
export const PUSH_TO_HISTORY_STACK = 'PUSH_TO_HISTORY_STACK'
export const SET_MESSAGES = 'SET_MESSAGES'
export const PUT_MESSAGE = 'PUT_MESSAGE'
export const SET_ACTIVE_MESSAGE = 'SET_ACTIVE_MESSAGE'
export const SET_TODAY_MESSAGES = 'SET_TODAY_MESSAGES'
export const SET_READ_MESSAGE = 'SET_READ_MESSAGE'
export const RESET_MESSAGES = 'RESET_MESSAGES'

export const SET_TOKEN_EXPIRE_MODAL_VISIBLE = 'SET_TOKEN_EXPIRE_MODAL_VISIBLE'
export const SET_WELLCOME_INVITED_USER = 'SET_WELLCOME_INVITED_USER'
export const SET_LOCALE = 'SET_LOCALE'

export const RESET_RO_FORM = 'RESET_RO_FORM'
export const SET_RO_SINGLE_POINT = 'SET_RO_SINGLE_POINT'
export const SET_RO_INPUT_SINGLE_POINT = 'SET_RO_INPUT_SINGLE_POINT'
export const SET_RO_MULTIPLE_POINTS = 'SET_RO_MULTIPLE_POINTS'
export const SET_RO_SERVICE = 'SET_RO_SERVICE'
export const SET_RO_ORDER_TIME = 'SET_RO_ORDER_TIME'
export const SET_RO_REQUESTS = 'SET_RO_REQUESTS'
export const SET_RO_SETTINGS = 'SET_RO_SETTINGS'
export const SET_RO_DRAFT_ORDERS = 'SET_RO_DRAFT_ORDERS'
export const UPDATE_RO_DRAFT_ORDERS = 'UPDATE_RO_DRAFT_ORDERS'
export const UPDATE_A_RO_DRAFT_ORDER = 'UPDATE_A_RO_DRAFT_ORDER'
export const RESET_RO_DRAFT_ORDERS = 'RESET_RO_DRAFT_ORDERS'
export const SET_RO_ESTIMATING_FEE = 'SET_RO_ESTIMATING_FEE'
export const SET_RO_CREATING_ORDERS = 'SET_RO_CREATING_ORDERS'
export const SET_JSON_PARAMS_INPUT = 'SET_JSON_PARAMS_INPUT'
export const SET_TRANSPORT_MODE = 'SET_TRANSPORT_MODE'

export const SET_MULTIPLE_PICKUP_POINTS_MODE = 'SET_MULTIPLE_PICKUP_POINTS_MODE'
export const SET_DELIVERY_TIME_WINDOWS_MODE = 'SET_DELIVERY_TIME_WINDOWS_MODE'
export const SET_PICKUP_POINT_LIST = 'SET_PICKUP_POINT_LIST'

export const ADD_ADDRESS = 'ADD_ADDRESS'
export const SET_ADDRESS_LIST = 'SET_ADDRESS_LIST'
export const SET_ADDRESS_DATA_LIST = 'SET_ADDRESS_DATA_LIST'
export const SAVE_ADDRESS_DATA = 'SAVE_ADDRESS_DATA'
export const SET_LATEST_SELECETED_ADDRESS = 'SET_LATEST_SELECETED_ADDRESS'

export const ADD_UPLOADED_ADDRESS = 'ADD_UPLOADED_ADDRESS'
export const SET_UPLOADED_ADDRESS_LIST = 'SET_UPLOADED_ADDRESS_LIST'
export const REMOVE_BULK_UPLOADED_ADDRESS = 'REMOVE_BULK_UPLOADED_ADDRESS'

export const GET_SERVICE_TYPES = 'GET_SERVICE_TYPES'
export const SET_SERVICE_TYPES = 'SET_SERVICE_TYPES'
export const LOADING_SERVICE_TYPES = 'LOADING_SERVICE_TYPES'
export const SET_DELIVERY_TYPES = 'SET_DELIVERY_TYPES'

export const SET_FINGERPRINT = 'SET_FINGERPRINT'

export const SET_LOADING_EXCEEDS_ORDER = 'SET_LOADING_EXCEEDS_ORDER'
export const SET_DOWNLOAD_TASK = 'SET_DOWNLOAD_TASK'
export const SET_DOWNLOAD_WORKER = 'SET_DOWNLOAD_WORKER'

export const SET_INSTRUCTION = 'SET_INSTRUCTION'

export const SET_CUSTOM_RO_PARAMS = 'SET_CUSTOM_RO_PARAMS'
export const RESET_CUSTOM_RO_PARAMS = 'RESET_CUSTOM_RO_PARAMS'
export const SET_RO_SENDER_INFO = 'SET_RO_SENDER_INFO'
export const SET_CURRENT_STATUS_OF_DATA_FROM_API = 'SET_CURRENT_STATUS_OF_DATA_FROM_API'

export const SET_SUPPLIER_LOCATION = 'SET_SUPPLIER_LOCATION'
export const RESET_SUPPLIER_LOCATION = 'RESET_SUPPLIER_LOCATION'
export const SET_SUPPLIER_ETA = 'SET_SUPPLIER_ETA'
export const RESET_SUPPLIER_ETA = 'RESET_SUPPLIER_ETA'
export const UPDATE_INVALID_ORDER_MODE_TO_GET_SUPPLIER_LOCATION =
  'UPDATE_INVALID_ORDER_MODE_TO_GET_SUPPLIER_LOCATION'

export const SET_PATH_DATA_TRUCK = 'SET_PATH_DATA_TRUCK'
export const SET_SERVICES_TRUCK = 'SET_SERVICES_TRUCK'
export const SET_SERVICE_TRUCK = 'SET_SERVICE_TRUCK'
export const UPDATE_FEE_TRUCK = 'UPDATE_FEE_TRUCK'
export const UPDATE_ESTIMATE_FEE_STATUS_TRUCK = 'UPDATE_ESTIMATE_FEE_STATUS_TRUCK'
export const UPDATE_ESTIMATE_FEE_ERROR_MESSAGE_TRUCK = 'UPDATE_ESTIMATE_FEE_ERROR_MESSAGE_TRUCK'
export const UPDATE_ORDER_REQUEST_TRUCK = 'UPDATE_ORDER_REQUEST_TRUCK'
export const ADD_ORDER_IMAGE_TRUCK = 'ADD_ORDER_IMAGE_TRUCK'
export const REMOVE_ORDER_IMAGE_TRUCK = 'REMOVE_ORDER_IMAGE_TRUCK'
export const UPDATE_ORDER_REMARKS_TRUCK = 'UPDATE_ORDER_REMARKS_TRUCK'
export const SET_ORDER_TIME_TRUCK = 'SET_ORDER_TIME_TRUCK'
export const DELETE_POINT_OF_PATH_TRUCK = 'DELETE_POINT_OF_PATH_TRUCK'
export const UPDATE_STATUS_CREATING_TRUCK = 'UPDATE_STATUS_CREATING_TRUCK'
export const RESET_DATA_TRUCK = 'RESET_DATA_TRUCK'
export const SET_SELECTED_DATE_CALENDAR = 'SET_SELECTED_DATE_CALENDAR'
export const REUSE_STATE_TO_CREATE_ORDER_TRUCK = 'REUSE_STATE_TO_CREATE_ORDER_TRUCK'
export const PREV_PATH_OF_ORDER_DETAIL_TRUCK = 'PREV_PATH_OF_ORDER_DETAIL_TRUCK'
export const SET_ORDER_FORM_PAYMENT_METHOD_TRUCK = 'SET_ORDER_FORM_PAYMENT_METHOD_TRUCK'

export const SET_ORDERS_TRUCK = 'SET_ORDERS_TRUCK'
export const UPDATE_LOADING_ORDERS_TRUCK_STATUS = 'UPDATE_LOADING_ORDERS_TRUCK_STATUS'

export const SET_SERVICE_WORKER_SUPPORT = 'SET_SERVICE_WORKER_SUPPORT'

export const SET_START_RO_TOUR_FROM_NEW_ORDER = 'SET_START_RO_TOUR_FROM_NEW_ORDER'
export const SET_OPEN_SELECT_CATEGORY = 'SET_OPEN_SELECT_CATEGORY'

// new UI
export const NEW_ORDER_SET_PATH = 'NEW_ORDER_SET_PATH'

export const ESTIMATE_FEE_REQUEST = 'ESTIMATE_FEE_REQUEST'
export const ESTIMATE_FEE_SUCCESS = 'ESTIMATE_FEE_SUCCESS'
export const ESTIMATE_FEE_FAILURE = 'ESTIMATE_FEE_FAILURE'
export const UPDATE_SHOULD_ESTIMATE_FEE_ALL_SERVICES = 'UPDATE_SHOULD_ESTIMATE_FEE_ALL_SERVICES'
export const UPDATE_SHOULD_SUGGEST_SERVICE_ALL_SERVICES =
  'UPDATE_SHOULD_SUGGEST_SERVICE_ALL_SERVICES'
export const SET_LOADING_SUGGEST_SERVICES = 'SET_LOADING_SUGGEST_SERVICES'

export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST'
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE'

export const SET_PROMOTION_LIST = 'SET_PROMOTION_LIST'
export const SET_FEATURED_BANNER = 'SET_FEATURED_BANNER'

export const UPDATE_SCROLL_BAR_WIDTH = 'UPDATE_SCROLL_BAR_WIDTH'

export const SET_NATIONWIDE_ESTIMATING_FEE = 'SET_NATIONWIDE_ESTIMATING_FEE'
export const SET_NATIONWIDE_ESTIMATED_FEE_ERROR = 'SET_NATIONWIDE_ESTIMATED_FEE_ERROR'
export const SET_NATIONWIDE_CREATING = 'SET_NATIONWIDE_CREATING'
export const SET_GHN_GEO_DATA = 'SET_GHN_GEO_DATA'
export const UPDATE_NATIONWIDE_PICKUP_CITY = 'UPDATE_NATIONWIDE_PICKUP_CITY'
export const SET_NATIONWIDE_PACKAGE_DETAIL = 'SET_NATIONWIDE_PACKAGE_DETAIL'

// Map actions
export const SET_PIN_ON_MAP_MODE = 'SET_PIN_ON_MAP_MODE'
export const UPDATE_PIN_PAYLOAD = 'UPDATE_PIN_PAYLOAD'
export const SET_PIN_ON_MAP_ICON = 'SET_PIN_ON_MAP_ICON'

export const SET_FB_PAGE_CONTACT = 'SET_FB_PAGE_CONTACT'

export const UPDATE_STATUS_SHOWED_ADD_BANK_MODAL = 'UPDATE_STATUS_SHOWED_ADD_BANK_MODAL'
export const UPDATE_STATUS_AUTO_REDEEMED_PROMO_CODE = 'UPDATE_STATUS_AUTO_REDEEMED_PROMO_CODE'

export const SET_KEY_ACCOUNT_PROFILE = 'SET_KEY_ACCOUNT_PROFILE'
export const SET_KEY_ACCOUNT_PROFILE_LOADED = 'SET_KEY_ACCOUNT_PROFILE_LOADED'

export const SET_BADGE_LIST = 'SET_BADGE_LIST'
export const SET_RATING_COMMENTS = 'SET_RATING_COMMENTS'

export const SET_REPORTS = 'SET_REPORTS'

export const SET_LASTEST_ORDER = 'SET_LASTEST_ORDER'
export const SET_STATUS_LOADING_LASTEST_ORDER = 'SET_STATUS_LOADING_LASTEST_ORDER'
export const SET_ORDER_LIST_HELP_CENTER = 'SET_ORDER_LIST_HELP_CENTER'
export const SET_LIST_TICKET_HELP_CENTER = 'SET_LIST_TICKET_HELP_CENTER'
export const SET_TICKET_COMMENT = 'SET_TICKET_COMMENT'
export const SET_LOADING_LASTEST_ORDER = 'SET_LOADING_LASTEST_ORDER'
export const SET_LOADING_TICKET_COMMENT = 'SET_LOADING_TICKET_COMMENT'

// Subscription

export const SET_SUBSCRIPTIONS_LIST = 'SET_SUBSCRIPTIONS_LIST'
export const SET_SUBSCRIPTION_DETAIL = 'SET_SUBSCRIPTION_DETAIL'
export const SET_MY_SUBSCRIPTION_LIST = 'SET_MY_SUBSCRIPTION_LIST'
export const SET_MY_SUBSCRIPTION_DETAIL = 'SET_MY_SUBSCRIPTION_DETAIL'
export const SET_SELECTED_SUBCRIPTION_PLAN = 'SET_SELECTED_SUBCRIPTION_PLAN'
export const SET_PAYMENT_METHODS_LIST = 'SET_PAYMENT_METHODS_LIST'
export const SET_POD_PAYMENT_METHODS_LIST = 'SET_POD_PAYMENT_METHODS_LIST'
export const SET_DATA_TRACKING_SUBSCRIPTION = 'SET_DATA_TRACKING_SUBSCRIPTION'

// end Subscription

// ZALOPAY BINDING
export const SET_STATUS_BIND_ZALOPAY = 'SET_STATUS_BIND_ZALOPAY'
export const SET_AUTO_DEBIT_ZALOPAY = 'SET_AUTO_DEBIT_ZALOPAY'

// VERIFY ACCOUNT
export const SET_ACTIVE_STEP_VERIFY_ACCOUNT = 'SET_ACTIVE_STEP_VERIFY_ACCOUNT'
export const SET_FORM_INFO_VERIFY_ACCOUNT = 'SET_FORM_INFO_VERIFY_ACCOUNT'

//
export const SET_ENABLE_HOMEPAGE = 'SET_ENABLE_HOMEPAGE'
export const SET_EKYC_PROVIDER = 'SET_EKYC_PROVIDER'

export const SET_ERROR_CODE_EKYC = 'SET_ERROR_CODE_EKYC'

// ITEM DESCRIPTIONS
export const SET_TRENDING_ITEM_DESCRIPTIONS = 'SET_TRENDING_ITEM_DESCRIPTIONS'
export const SET_SUGGESTION_ITEM_DESCRIPTIONS = 'SET_SUGGESTION_ITEM_DESCRIPTIONS'
export const SET_LOADING_SUGGESTIONS = 'SET_LOADING_SUGGESTIONS'
//FAVORITE DRIVERS
export const LOADING_FAVORITE_DRIVER = 'LOADING_FAVORITE_DRIVER'
export const LOAD_FAVORITE_DRIVER_SUCCESS = 'LOAD_FAVORITE_DRIVER_SUCCESS'
export const ADD_DRIVER_SUCCESS = 'ADD_DRIVER_SUCCESS'
export const REMOVE_DRIVER_SUCCESS = 'REMOVE_DRIVER_SUCCESS'

// SHOPEEPAY BINDING
export const SET_STATUS_BIND_SHOPEEPAY = 'SET_STATUS_BIND_SHOPEEPAY'
export const SET_AUTO_DEBIT_SHOPEEPAY = 'SET_AUTO_DEBIT_SHOPEEPAY'

export const SET_TRUCK_SERVICE = 'SET_TRUCK_SERVICE'
export const UPDATE_ITEM_DESCRIPTION_TRUCK = 'UPDATE_ITEM_DESCRIPTION_TRUCK'
export const GET_SERVICE_TYPES_TRUCK = 'GET_SERVICE_TYPES_TRUCK'
export const GET_DRAFT_ORDER_PUBLIC_SUCCESS = 'GET_DRAFT_ORDER_PUBLIC_SUCCESS'
export const DRAFT_ORDER_FAIL = 'DRAFT_ORDER_FAIL'
export const CREATE_ORDER_FORM = 'CREATE_ORDER_FORM'
export const EDIT_ORDER_FORM = 'EDIT_ORDER_FORM'
export const REMOVE_ORDER_FORM = 'REMOVE_ORDER_FORM'
export const GET_LIST_ORDER_FORM = 'GET_LIST_ORDER_FORM'
export const GET_LIST_DRAFT_ORDER = 'GET_LIST_DRAFT_ORDER'
export const ADD_DRAFT_ORDER = 'ADD_DRAFT_ORDER'
export const EDIT_DRAFT_ORDER = 'EDIT_DRAFT_ORDER'
export const REMOVE_DRAFT_ORDER = 'REMOVE_DRAFT_ORDER'
export const GET_LIST_DRAFT_ORDER_MORE = 'GET_LIST_DRAFT_ORDER_MORE'

export const SET_RO_NORMAL_ORDER = 'SET_RO_NORMAL_ORDER'
export const SET_PARTNER_PROFILE = 'SET_PARTNER_PROFILE'
export const CLEAN_ORDER_FORM_PATH = 'CLEAN_ORDER_FORM_PATH'

export const SET_TIP_INFO = 'SET_TIP_INFO'

export const SET_WITHDRAW_PAYMENT_METHODS = 'SET_WITHDRAW_PAYMENT_METHODS'

export const GET_ALL_TRANSACTION_TYPES = 'GET_ALL_TRANSACTION_TYPES'
export const SET_HAVE_GET_FULFILLMENT_ORDER = 'SET_HAVE_GET_FULFILLMENT_ORDER'

export const SET_SECOND_HIDE_TIPS = 'SET_SECOND_HIDE_TIPS'
export const SET_SECOND_HIDE_REIMBURSEMENT = 'SET_SECOND_HIDE_REIMBURSEMENT'

export const ADD_BOOKING_DESCRIPTION = 'ADD_BOOKING_DESCRIPTION'
export const SET_ORDER_FORM_NUMBER_OF_DRIVERS = 'SET_ORDER_FORM_NUMBER_OF_DRIVERS'
export const SET_ORDER_FORM_HOURS_OF_RENTAL = 'SET_ORDER_FORM_HOURS_OF_RENTAL'

export const SET_ALLOWED_VEHICLES = 'SET_ALLOWED_VEHICLES'

export const SET_ORDER_DEFAULT_TRUCK_SERVICE = 'SET_ORDER_DEFAULT_TRUCK_SERVICE'
export const RESET_IS_VALID_ORDER_FORM = 'RESET_IS_VALID_ORDER_FORM'
export const SET_INIT_LOCATION = 'SET_INIT_LOCATION'

export const SET_ACTIVE_ENTRY_POINT = 'SET_ACTIVE_ENTRY_POINT'

export const SET_OAUTH_PENDING_AUTH_REQUEST = 'SET_OAUTH_PENDING_AUTH_REQUEST'
export const SET_OAUTH_PARTNER_INFO = 'SET_OAUTH_PARTNER_INFO'
export const SET_OAUTH_REQUESTED_SCOPES = 'SET_OAUTH_REQUESTED_SCOPES'
export const CLEAR_OAUTH_PENDING_REQUEST = 'CLEAR_OAUTH_PENDING_REQUEST'
